import React from 'react';
import { Outlet } from 'react-router-dom';
import AppSidebar from './AppSidebar';

function AppLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-white dark:bg-gray-900">
      <AppSidebar />
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;
